import arrowImg from '@/static/assets/how_it_works/Giveback_Arrow.svg';
import { Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import Image from 'next/image';
import { useMemo } from 'react';
import styled from 'styled-components';
import type { HowItWorksProps } from '..';
import { HOW_IT_WORKS_DEFAULTS } from '../defaults';

const ImageDesktop = styled(Image)`
  display: none;
  pointer-events: none;
  ${MEDIA_QUERIES.tabletAndDesktop`
    display: block;
  `}
`;

const ImageMobile = styled(Image)`
  display: block;
  pointer-events: none;
  ${MEDIA_QUERIES.tabletAndDesktop`
    display: none;
  `}
`;

const Arrow = styled(Image)`
  display: block;
  margin: 0 auto;
  height: 70px;
  pointer-events: none;
  ${MEDIA_QUERIES.tabletAndDesktop`
    height: 70px;
  `}
`;

type BrandsImageProps = Pick<HowItWorksProps, 'brandsImage' | 'showBrandsImage'>;

const defaultBrands = HOW_IT_WORKS_DEFAULTS.brandsImage;
export const BrandsImage: React.FC<BrandsImageProps> = ({ brandsImage, showBrandsImage }) => {
  const { desktop, mobile } = useMemo(() => {
    return {
      desktop: brandsImage?.desktop ?? defaultBrands.desktop,
      mobile: brandsImage?.mobile ?? defaultBrands.mobile,
    };
  }, [brandsImage]);

  if (!showBrandsImage) return null;

  return (
    <>
      <Arrow src={arrowImg} alt="" />
      <Flex mt={[30, 50]} mb={[30, 0]} width="100%" positon="relative" justifyContent="center">
        <ImageDesktop src={desktop} alt="Brands logos" loading="lazy" style={{ objectFit: 'contain', width: '100%' }} />
        <ImageMobile src={mobile} alt="Brands logos" loading="lazy" style={{ objectFit: 'contain', width: '100%' }} />
      </Flex>
    </>
  );
};
